<template>
    <SbsBaseButton
        v-bind="buttonData"
        class="sbs-button-icon trs">
        <!-- @slot Слот по-умолчанию -->
        <slot>
            <SbsIcon
                class="sbs-button-icon__icon"
                v-bind="iconData" />
        </slot>
    </SbsBaseButton>
</template>

<script>
import dimensionsMixin from '../../mixins/dimensions.js';
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import {
    AllSizes,
    APP_SIZES,
} from '../../utils/sizes.js';
import {
    AllIconGroups,
    ICON_GROUPS,
    ICON_ANIMATIONS,
} from '../icon/utils/consts.js';

/**
 * Компонент кнопки-иконки.
 * По-умолчанию рендерится икнока FontAwesome, также можно прокинуть свою через слот
 */
export default {
    name: 'SbsButtonIcon',
    mixins: [dimensionsMixin, themesMixin],
    computed: {
        buttonClasses() {
            return [
                ...this.themeClasses,
                this.$attrs.class,
                {
                    disabled: this.disabled,
                },
            ];
        },
        buttonStyles() {
            return {
                ...this.$attrs.style,
                ...this.dimensionStyles,
            };
        },
        buttonData() {
            return {
                ...this.$attrs,
                class: this.buttonClasses,
                disabled: this.disabled,
                style: this.buttonStyles,
                to: this.to,
            };
        },
        iconData() {
            return {
                animation: this.animation,
                iconGroup: this.iconGroup,
                iconName: this.iconName,
                iconSize: this.iconSize,
            };
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Название класса, отвечающего за анимацию иконки
         */
        animation: {
            type: String,
            default: '',
            validator: value => !value || isArrayContainsValue(ICON_ANIMATIONS),
        },
        /**
         * Отключает взаимодействие с компонентом
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Стиль (группа) иконки
         */
        iconGroup: {
            type: String,
            default: AllIconGroups.REGULAR,
            validator: isArrayContainsValue(ICON_GROUPS),
        },
        /**
         * Название иконки из FontAwesome.
         * Список всех иконок можно посмотреть [здесь](https://fontawesome.com/v6/icons)
         */
        iconName: {
            type: String,
            default: 'xmark',
        },
        /**
         * Размер кнопки-иконки
         */
        iconSize: {
            type: String,
            default: AllSizes.MEDIUM,
            validator: isArrayContainsValue(APP_SIZES),
        },
        /**
         * Роут для `<RouterLink>`.
         * Может быть строкой, либо объектом.
         * Имеет более высокий приоритет перед `href`
         */
        to: {
            type: [Object, String],
            default: null,
        },
    },
};
</script>

<style lang="scss">
.sbs-button-icon {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-size: 20px;

    &.disabled {
        opacity: 0.5;
    }

    &::after {
        position: absolute;
        top: -0.25em;
        right: -0.25em;
        bottom: -0.25em;
        left: -0.25em;
        z-index: 2;
        content: "";
    }

    &__icon {
        position: relative;
        z-index: 1;
        width: 1em;
    }
}
</style>
